<script setup>
  import Sidebar from './views/Sidebar.vue'
  import Topbar from './views/Topbar.vue'
</script>

<template>
  <div class="flex w-full h-screen bg-gray-50">
    <div class="w-full flex-1">
      <router-view />
    </div>
    <!-- <div class="w-1/6">
      <Sidebar />
    </div> -->

    <!-- <div class="flex-1 w-5/6 overflow-y-auto">
      <Topbar />

      <router-view />
    </div> -->
  </div>
</template>

<style scoped>
.logo {
  height: 6em;
  padding: 1.5em;
  will-change: filter;
  transition: filter 300ms;
}
.logo:hover {
  filter: drop-shadow(0 0 2em #646cffaa);
}
.logo.vue:hover {
  filter: drop-shadow(0 0 2em #42b883aa);
}
</style>
